import React from 'react';
import { Container, Grid, Card, CardMedia, CardContent, CardActionArea, Typography, Box } from '@mui/material';
import Na4wxLogo from '../images/NA4WX Logo.png';
import stormImage from '../images/storm.jpg';
import hamRadioImage from '../images/ham_radio.jpg';
import softwareDevImage from '../images/software_dev.jpg';
import { useNavigate } from 'react-router-dom';

const highlights = [
  {
    title: 'Amateur Radio',
    image: hamRadioImage,
    to: '/hamradio',
    text: 'NA4WX, Jordan is an experienced amateur radio operator, contributing to the community through communication, emergency services, and technology.',
  },
  {
    title: 'Software Development',
    image: softwareDevImage,
    to: '/development',
    text: 'Proficient in React, Node.js, JavaScript, Python, VB.NET, and Java, Jordan develops innovative software solutions and shares his projects on GitHub.',
  },
  {
    title: 'Weather Spotting',
    image: stormImage,
    to: '/about',
    text: 'Jordan plays a crucial role in monitoring severe weather conditions, gathering data, and ensuring public safety as a District 5 Assistant Skywarn Coordinator.',
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Box
          component="img"
          src={Na4wxLogo}
          alt="Jordan Webb"
          sx={{ width: '100%', maxWidth: 300, borderRadius: 0, boxShadow: 0 }}
        />
      </Grid>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 5 }}>
        Jordan Webb, known as NA4WX in the amateur radio community, is a dedicated weather spotter, skilled software
        developer, and active member of the East Tennessee community.
      </Typography>
      <Grid container spacing={3}>
        {highlights.map((item) => (
          <Grid size={{ xs: 12, md: 4 }} key={item.title}>
            <Card sx={{ height: '100%' }}>
              <CardActionArea onClick={() => navigate(item.to)} sx={{ height: '100%' }}>
                <CardMedia component="img" height="200" image={item.image} alt={item.title} />
                <CardContent>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.text}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Home;
